var styleDataHash = '6709a77d';  
export const injectCss = (() => {
  var css = `.KC-j6,.cvBau{align-items:center;box-sizing:border-box;display:inline-block;display:flex;justify-content:center;position:absolute}[dir] .KC-j6,[dir] .cvBau{background-color:rgba(var(--ricos-text-color-tuple,33,33,33),.1)}.KC-j6:hover:not(.RoHAj),.cvBau:hover:not(.RoHAj){color:var(--ricos-settings-action-color,var(--ricos-action-color,#116dff))}[dir] .KC-j6:hover:not(.RoHAj),[dir] .cvBau:hover:not(.RoHAj){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-tuple,2,97,255)),.2)}.KC-j6{bottom:-20px;height:20px;width:calc(100% + 20px)}[dir] .KC-j6{border-bottom:1px solid #c7c3c3;border-top:1px solid #c7c3c3}[dir=ltr] .KC-j6{border-left:1px solid #c7c3c3;left:-20px}[dir=rtl] .KC-j6{border-right:1px solid #c7c3c3;right:-20px}.cvBau{height:calc(100% + 40px);top:-20px;width:20px}[dir] .cvBau{border:1px solid #c7c3c3}[dir=ltr] .cvBau{right:-20px}[dir=rtl] .cvBau{left:-20px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "tableAddRow": "KC-j6",
  "tableAddCol": "cvBau",
  "disabled": "RoHAj"
};